
import React from 'react'
import { Row ,Col} from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import LayoutWithOutAccountCard from "../Layout/layout-without-card";
import { DOWNLOAD_CENTER_MENUS } from '../Layout/menu-names';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { getMenuListSelector } from '../../store/selectors/app.selector';

export default function DownLoadCenter() {
  const history = useHistory()
  const {t}=useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['DOWNLOAD_CENTER'] || {}
  return (
      <LayoutWithOutAccountCard
       breadCumKey="DOWNLOAD_CENTER"
        keyPath={'DOWNLOAD_CENTER'}
        showEmptySpace={true}>
        <Row>
          {Object.keys(menuConfig).length>0 && DOWNLOAD_CENTER_MENUS.map((option, index) => (
            <>
            {menuConfig[option.key] && (
            <Col
              onClick={() => history.push(option.link)}
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              className='account-menu-card'>
              <img width={52} height={40} src={option.icon} />
              <h2>{t(option.title)}</h2>
              <span>{option.desc}</span>
            </Col>
            )}
            </>
          ))}
        </Row>
      </LayoutWithOutAccountCard>
  )
}
